import AddButton from "components/Button/AddButton";
import React, { useEffect, useRef, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, PageSize, StatusCodeActive, StatusCodeDelete, ViewDateFormat } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import Dropdown from "components/Input/Dropdown";
import { GetExpenseCategory, GetStatus, money } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import { useModal } from "utils/context/ModalContext";
import { ExpenseService } from "services/ExpenseService";
import Pagination from "components/Input/PaginationButton";
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { FilterCard } from "components/Cards/FilterCard";
import { PagesTitle } from "components/Cards/PagesTitle";
import DataTable from "components/DataTable";
import { GridEditButton } from "components/Button/GridEditButton";
import { GridDeleteButton } from "components/Button/GridDeleteButton";

export default function Expense(){
    let navigate = useNavigate()

    const firstLoad = useRef(true)
    const debounceRef = useRef(null)

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchExpenseList, fetchDeleteExpense } = ExpenseService()

    const [dateFrom, setDateFrom] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
    const [dateTo, setDateTo] = useState(new Date())
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    // DATA
    const [expenseList, setExpenseList] = useState([])

    // GRID
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "expenseDate",
            header: "Expense Date",
            render: (row) => moment(row.paymentDate).format('DD MMM YYYY')
        },
        {
            key: "expenseCategory",
            header: "Category",
            render: (row) => GetExpenseCategory(row.expenseCategory)
        },
        {
            key: "amount",
            header: "Amount",
            render: (row) => 'Rp ' + money(row.amount),

        },
        {
            key: "remark",
            header: "Remark",
            // render: (row) => GetMonth(row.paymentPeriodeMonth) + ' ' + row.paymentPeriodeYear
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    {/* <GridViewButton onClick={() => viewBtnClick(row.customerId)} size="w-3" /> */}
                    <GridEditButton isActive={row.status} onClick={() => editBtnClick(row.expenseId)} size="w-3" />
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.expenseId, row.status)} size="w-3" />
                </div>
            ),
        },
    ]

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            const res = await fetchExpenseList(
                moment(dateFrom).format('yyyy-MM-DD'),
                moment(dateTo).format('yyyy-MM-DD'),
                status,
                PageSize,
                newIndex
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setExpenseList(res)

            setTotalPages(total)
            setPageIndex(newIndex)
        } finally {
            hideLoading()
        }
    }

    const addBtnClick = () => {
        navigate("/expense/form?expenseId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (expenseId) => {
        navigate("/expense/form?expenseId=" + expenseId + "&formType=Edit")
    }
    const deleteBtnClick = async (expenseId, status) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchDeleteExpense(expenseId, status)
            await handlePageChange(pageIndex)
        } finally {
            hideLoading()
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            if (firstLoad.current) {
                handlePageChange(0)

                firstLoad.current = false
            }
            else {
                if (debounceRef.current) {
                    clearTimeout(debounceRef.current)
                }
        
                debounceRef.current = setTimeout(() => {
                    handlePageChange(0)
                }, 500)
            }
        }

        onLoad()
    },[dateFrom, dateTo, status])

    return(
        <MainBodyCard>
            <PagesTitle title='Expense' />

            <div className="flex flex-col sm:flex-row flex-wrap gap-4 mt-5">
                <FilterCard title='Date From' width='w-full sm:w-64'>
                    <DatePicker className="bg-white h-10 w-full" value={dateFrom} onChange={(e) => { setDateFrom(e) }} />
                </FilterCard>

                <FilterCard title='Date To' width='w-full sm:w-64'>
                    <DatePicker className="bg-white h-10 w-full" value={dateTo} onChange={(e) => { setDateTo(e) }} />
                </FilterCard>

                <FilterCard title='Status' width='w-full sm:w-32'>
                    <Dropdown className='w-full' value={status} options={DropdownStatusList} onChange={(e) => {setStatus(e.value)}} placeholder={"All"} />
                </FilterCard>
            </div>

            <div className="mt-4 flex w-full justify-end">
                <AddButton onClick={addBtnClick} title='Tambah Expense' />
            </div>
           
            <div className="mt-4 hidden sm:block">
                <DataTable
                    columns={columns}
                    data={expenseList?.data?.listData ?? []}
                    footer={
                        <tr className="h-10">
                            <td colSpan={3} className="text-right pr-2">Total</td>
                            <td colSpan={1} className="text-right pr-2" >{"Rp " + money(String(expenseList?.data?.totalExpense))}</td>
                        </tr>
                    }
                />
            </div>

            <div className="mt-5 sm:hidden flex flex-col gap-2">
                {expenseList?.data?.listData.length > 0 ? (
                    expenseList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="border rounded-md hover:bg-slate-100 bg-white py-2 px-2 flex justify-between" key={ i }>
                                <div className="text-sm">
                                    <div>
                                        <span>{ data.remark }</span>
                                    </div>                                
                                    <div>
                                        <span className="font-semibold">{ "Rp " + money(data.amount) }</span>
                                    </div>
                                    <div className="mt-1 flex gap-2">
                                        <button className="bg-black px-3 py-1 rounded-md flex gap-2" onClick={() => editBtnClick(data.expenseId)}>
                                            <EditIcon className="w-4 fill-white" />
                                            <span className="text-white">Edit</span>
                                        </button>
                                        <button className={`bg-black px-3 py-1 rounded-md flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.expenseId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                            <span className="text-white">Delete</span>
                                        </button>
                                        <button className={`bg-black px-3 py-1 rounded-md flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.expenseId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                            <span className="text-white">Undelete</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="flex flex-col text-right text-sm">
                                    <div>
                                        <span>{ moment(data.expenseDate).format(ViewDateFormat) }</span>
                                    </div>
                                    <div>
                                        <span>{ GetExpenseCategory(data.expenseCategory) }</span>
                                    </div>
                                    <div className="flex h-full items-center justify-end">
                                        <span>{  }</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })) :
                (
                    <div className="bg-white border rounded-md py-4 flex justify-center">
                        <span>No data</span>
                    </div>
                )
            }                
            </div>  

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}